export class TimeAgo
{
    static settings = {
        now: "just now",
        seconds: "%d second ago",
        minute: "a minute ago",
        minutes: "%d minutes ago",
        hour: "an hour ago",
        hours: "%d hours ago",
        day: "a day ago",
        days: "%d days ago",
        month: "a month ago",
        months: "%d months ago",
        year: "a year ago",
        years: "%d years ago"
    };

    // Get string from number
    static getStrFromNum(strValue: string, num: number)
    {
        return strValue.replace(/%d/i, num.toString());
    }

    static inWords(inpDate: Date)
    {
        // Get time distance from now (in milliseconds)
        let timeDist = new Date().getTime() - inpDate.getTime();

        // Get time components
        let seconds = Math.abs(timeDist) / 1000;
        let minutes = seconds / 60;
        let hours = minutes / 60;
        let days = hours / 24;
        let years = days / 365;

        // return words
        let words =
            seconds < 30 && TimeAgo.getStrFromNum(TimeAgo.settings.now, 0) ||
            seconds < 60 && TimeAgo.getStrFromNum(TimeAgo.settings.seconds, Math.round(seconds)) ||
            seconds < 120 && TimeAgo.getStrFromNum(TimeAgo.settings.minute, 1) ||
            minutes < 60 && TimeAgo.getStrFromNum(TimeAgo.settings.minutes, Math.round(minutes)) ||
            minutes < 120 && TimeAgo.getStrFromNum(TimeAgo.settings.hour, 1) ||
            hours < 24 && TimeAgo.getStrFromNum(TimeAgo.settings.hours, Math.round(hours)) ||
            hours < 48 && TimeAgo.getStrFromNum(TimeAgo.settings.day, 1) ||
            days < 30 && TimeAgo.getStrFromNum(TimeAgo.settings.days, Math.round(days)) ||
            days < 60 && TimeAgo.getStrFromNum(TimeAgo.settings.month, 1) ||
            days < 365 && TimeAgo.getStrFromNum(TimeAgo.settings.months, Math.round(days / 30)) ||
            years < 1.5 && TimeAgo.getStrFromNum(TimeAgo.settings.year, 1) ||
            TimeAgo.getStrFromNum(TimeAgo.settings.years, Math.round(years))
            ;

        return words;
    };

    static timeAgo(someValue: any): string
    {
        if (someValue instanceof Date)
        {
            return TimeAgo.inWords(someValue);
        }
        else if (typeof someValue === "number")
        {
            return TimeAgo.inWords(new Date(someValue));
        }
        else if (typeof someValue === "string" && new Date(someValue).toString() != 'Invalid Date')
        {
            return TimeAgo.inWords(new Date(someValue));
        }
        else
        {
            return someValue; // could not convert
        }
    }

};